<template>
  <div>
    <div class="row">
      <div class="col-md-12 mt-4">
        <TableSearch
          :data="searchContact"
          :headers="contactHeaders"
          @update:searchText="handleSearchTextUpdate"
          :checkMultipleItem="false"
          :filterItem="false"
        >
          <template v-slot:firstName="{ item }">
            <router-link
              class="text-decoration-none text-dak"
              :to="{
                name: 'FirsttimerManagement',
                params: { personId: item.id },
                query: { memberType: item.memberType },
              }"
            >
              <div>
                {{ item.firstName }}
              </div>
            </router-link>
          </template>
          <template v-slot:lastName="{ item }">
            <router-link
              class="text-decoration-none text-dak"
              :to="{
                name: 'FirsttimerManagement',
                params: { personId: item.id },
                query: { memberType: item.memberType },
              }"
            >
              <div class="c-pointer">
                {{ item.lastName }}
              </div>
            </router-link>
          </template>
          <template v-slot:email="{ item }">
            <router-link
              class="text-decoration-none text-dak"
              :to="{
                name: 'FirsttimerManagement',
                params: { personId: item.id },
                query: { memberType: item.memberType },
              }"
            >
              <div>
                {{ item.email }}
              </div>
            </router-link>
          </template>
          <template v-slot:mobilePhone="{ item }">
            <router-link
              class="text-decoration-none text-dak"
              :to="{
                name: 'FirsttimerManagement',
                params: { personId: item.id },
                query: { memberType: item.memberType },
              }"
            >
              <div>
                {{ item.mobilePhone }}
              </div>
            </router-link>
          </template>
          <template v-slot:action="{ item }">
            <el-dropdown trigger="click">
              <el-icon>
                <MoreFilled />
              </el-icon>
              <template #dropdown>
                <el-dropdown-menu>
                  <el-dropdown-item>
                    <div
                      @click.prevent="showConfirmModal(item.id, index)"
                      class="text-color"
                    >
                      Delete
                    </div>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </template>
            </el-dropdown>
          </template>
        </TableSearch>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, computed } from "vue";
import { ElNotification, ElMessageBox } from "element-plus";
import TableSearch from "../../../components/table/TableSearch.vue";
export default {
  props: ["contacts"],
  components: {
    TableSearch,
  },
  setup(props) {
    const searchText = ref("");
    const contactHeaders = ref([
      { name: "FIRST NAME", value: "firstName" },
      { name: "LAST NAME", value: "lastName" },
      { name: "EMAIL", value: "email" },
      { name: "PHONE", value: "mobilePhone" },
      { name: "ACTION", value: "action" },
    ]);

    const handleSearchTextUpdate = (newValue) => {
      searchText.value = newValue;
    };

    const searchContact = computed(() => {
      if (!searchText.value.trim()) {
        return props.contacts;
      }
      return props.contacts.filter((item) =>
        Object.values(item)
          .join(" ")
          .toLowerCase()
          .includes(searchText.value.toLowerCase())
      );
    });
    const deleteContact = (id) => {
      props.contacts = props.contacts.filter((item) => item.id !== id);

      //   axios
      //     .delete(`/api/Forms/deleteform?Id=${id}`)
      //     .then((res) => {
      //       console.log(res);
      //       ElNotification({
      //         type: "success",
      //         message: "Contact deleted successfully",
      //         duration: 5000,
      //       });
      //       props.contacts = props.contacts.filter(
      //         (item) => item.id !== id
      //       );
      //     })
      //     .catch((err) => {
      //       if (err.response.status === 400) {
      //         ElNotification({
      //           type: "error",
      //           message: "Unable to delete",
      //           duration: 5000,
      //         });
      //       } else {
      //         ElNotification({
      //           type: "error",
      //           message: "Unable to delete",
      //           duration: 5000,
      //         });
      //       }
      //     });
    };
    const showConfirmModal = (id, index) => {
      ElMessageBox.confirm(
        "Are you sure you want to proceed?",
        "Confirm delete",
        {
          confirmButtonText: "OK",
          cancelButtonText: "Cancel",
          type: "error",
        }
      )
        .then(() => {
          deleteContact(id, index);
        })
        .catch(() => {
          ElNotification({
            type: "info",
            message: "Delete canceled",
            duration: 5000,
          });
        });
    };
    return {
      handleSearchTextUpdate,
      deleteContact,
      showConfirmModal,
      contactHeaders,
      searchText,
      searchContact,
    };
  },
};
</script>

<style scoped>
.table-header {
  background: #f1f3f9 !important;
  color: #8898aa !important;
  font-size: 11px !important;
  text-align: left !important;
  box-shadow: 0px 3px 6px #2c28281c !important;
}
</style>
